import React, { lazy, Suspense } from "react";
import "./i18n";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import RootRoutes from "./routes/RootRoutes";
import ScrollToTop from "./default/components/ScrollToTop";

const AgentationToolbar = process.env.NODE_ENV === "development"
  ? lazy(() => import("agentation").then((mod) => ({ default: mod.Agentation })))
  : null;

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/*" element={<RootRoutes />} />
      </Routes>
      {AgentationToolbar && (
        <Suspense fallback={null}>
          <AgentationToolbar endpoint="http://localhost:4747" />
        </Suspense>
      )}
    </Router>
  );
}

export default App;
